import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import {
  PackageSummary,
  SocialAccountType,
  PackageInfluencer,
  SocialAccountStatus,
  PackageSocialAccount,
  ProposalJobDescriptionBreakDownMode
} from '@anytag/graphql';
import { ProposeInfluencersFilterSchema, ProposeInfluencersTableMode } from '../../../Influencers';

export interface PackageProposedInfluencer extends PackageSummary, Omit<PackageInfluencer, 'accountList' | 'summary'> {
  accountList: readonly PackageSocialAccount[];
}
export interface RowPackageInfluencerData {
  id: number;
  name: string;
  avatar?: string | null;
  status: SocialAccountStatus;
}

export interface RowPackageSocialAccountData {
  id: number;
  name?: string | null;
  lastIndex?: boolean;
  socialMedia: SocialAccountType;
}
export interface RowPackageStatsData {
  budget: number;
  profit: number;
  influencerCost: number;
  addedDate?: string | null;
  followersCount?: number | null;
  engagementRateByViews?: number | null;
  engagementRateByFollowers?: number | null;
  engagementPosted?: number | null;
  engagementProposed?: number | null;
}

export interface RowPackageData {
  index: number;
  className?: string;
  isEditable: boolean;
  stats: RowPackageStatsData;
  influencer: RowPackageInfluencerData;
  socialAccount?: RowPackageSocialAccountData;
}

export enum PackageContentTabType {
  INFLUENCERS_LIST = 'INFLUENCERS_LIST',
  ADD_INFLUENCER = 'ADD_INFLUENCER'
}

export const PackageProposalSearchSchema = SearchSchema.create({
  filter: {
    schema: ProposeInfluencersFilterSchema.extend({ keyword: SearchSchema.types.string() }),
    defaultValues: {
      tableViewMode: ProposeInfluencersTableMode.VIEW,
      jdMode: ProposalJobDescriptionBreakDownMode.SOCIAL_BREAKDOWN
    }
  }
});

export type PackageProposalSearchSchemaType = z.infer<typeof PackageProposalSearchSchema>;
export type PackageProposalFilterFormValues = PackageProposalSearchSchemaType['filter'];
